<template>
  <b-modal
    id="addLogo"
    class="mc-modal"
    :title="$t('setting.list.company.form.uploadPhoto')"
    size="md"
    centered
    scrollable
  >
    <form class="mc-form">
      <b-row>
        <b-form-group>
          <div class="mc-upload__file-wrapper">
            <div v-if="fileProp.name == null" class="mc-upload__file-area">
              <input
                id="inputfile"
                ref="inputfile"
                type="file"
                name="attachment"
                class="mc-upload__file-area-input"
                accept=".png, .jpg, .jpeg"
                @change="onFileChange"
                @drop="onFileChange"
              />

              <div class="mc-upload__file-area-text">
                <i class="mc-fa icon-outline_upload" />
                <p>{{ $t('setting.list.company.form.uploadDesc1') }}</p>
                <p>{{ $t('setting.list.company.form.uploadDesc2') }}</p>
              </div>
            </div>
            <div
              v-else
              :class="`mc-upload__file-result ${
                fileProp.error ? 'mc-upload__file-result--error' : null
              }`"
            >
              <div class="mc-upload__file-result-wrapper">
                <i class="mc-fa icon-outline_file" />
                <h4 class="mc-upload__file-result-status">
                  {{ fileProp.message }}
                </h4>
                <div class="mc-upload__file-result-desc d-flex justify-content-between">
                  <span>{{ fileProp.name }}</span>
                  <span v-if="fileProp.error">
                    <i class="mc-fa icon-outline_trash-2" @click="deleteFile" />
                    <i class="mc-fa icon-fill_alert-triangle" />
                  </span>
                </div>
                <div class="mc-upload__file-result-progress">
                  <div :style="`width: ${fileProp.progressVal}%`" />
                </div>
                <span class="mc-upload__file-result-filesize">
                  <span>{{ fileProp.sizeProgress }} MB / </span>{{ fileProp.size }} MB
                </span>
              </div>
            </div>
          </div>
        </b-form-group>
      </b-row>
      <b-row class="mt-2">
        <b-col md="12">
          <FormulateInput
            id="note"
            v-model="note"
            type="textarea"
            :label="$t('setting.list.company.form.note')"
            :placeholder="$t('setting.list.company.form.note')"
            trim
          />
        </b-col>
      </b-row>
    </form>
    <template #modal-footer="{ cancel }">
      <b-row class="mc-modal__filter-footer mx-0">
        <b-col sm="12" md="12" class="mc-modal__filter-footer-btn">
          <McButton
            variant="secondary"
            :text="$t('global.action.cancel')"
            class="me-2"
            @click="cancel()"
          />
          <McButton variant="primary" :text="$t('global.action.upload')" />
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>

<script>
import McButton from '@/components/McButton'
export default {
  components: {
    McButton,
  },

  props: {
    fileProp: {},
  },

  data() {
    return {
      isFileError: false,
      note: '',
    }
  },

  methods: {
    onFileChange(e) {
      this.$emit('updateOnChange', e)
    },
    deleteFile() {
      this.$emit('deleteFile')
    },
  },
}
</script>
